import { IconButton } from "@mui/material";
import { formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";
import { DeleteIcon } from "../../Icons/Icons";

function ScheduleCard({ Avatar, item, handleDeleteOnClick, handleCardOnClick }) {
  return (
    <TilleyCard
      Avatar={Avatar}
      onClick={handleCardOnClick}
      subtitle={item?.account_name || item?.name}
      title={item?.financial_institution_name + " (" + item?.account_type + ")"}
      details={[
        {
          value: formatPrice(item?.value, 0),
          label: "Value",
        },
        {
          value: formatPrice(item?.adjusted_value, 0),
          label: "Adjusted Value",
        },
      ]}
      action={
        <>
          <IconButton
            onClick={(e) => {
              handleDeleteOnClick(item);
              e.stopPropagation();
              return false;
            }}
          >
            <DeleteIcon />
          </IconButton>
        </>
      }
    />
  );
}

export default ScheduleCard;
